import React from 'react';
import { useSelector } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';

import Quoter from '../components/Quoter';
import QuoterProgress from '../components/QuoterProgress';
import QuoterSummary from '../components/QuoterSummary';

const QuoterContainer = () => {
  const quoterCurrentStep = useSelector((state) => state.appConfig.quoterCurrentStep);

  return (
    <>
      {quoterCurrentStep >= 4 && (
        <>
          <QuoterSummary />
          <QuoterProgress />
        </>
      )}
      <Router>
        <Quoter />
      </Router>
    </>
  );
};

export default QuoterContainer;
